import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"

import BaseRow from "@cirrus/legacy/app-components/table-v2/table-rows/base-row/index.jsx"
import TableColumn from "@cirrus/legacy/app-components/table-v2/table-column/index.jsx"
import Checkbox from "@cirrus/legacy/app-components/form-controls/checkboxes/checkbox/index.jsx"

import CommonStyles from "@cirrus/legacy/app-components/table-v2/common-styles/styles.less"

class CheckboxRow extends C {
  static displayName = "TableRow"

  static propTypes = {
    id: PropTypes.string.isRequired,
    onSelect: PropTypes.func.isRequired,
    isSelected: PropTypes.bool.isRequired,
    isDisabled: PropTypes.bool,
    isCheckboxColumnWidthControlled: PropTypes.bool,
    extraInfo: PropTypes.object,
    highlighteRow: PropTypes.bool,
    highlightOnSelect: PropTypes.bool,
  }

  static defaultProps = {
    isCheckboxColumnWidthControlled: true,
    highlightOnSelect: true,
    highlighteRow: true,
    extraInfo: {},
  }

  handleCheck = (e, checked) => {
    this.props.onSelect(checked, this.props.id, this.props.extraInfo)
  }

  onClickHandle(e) {
    e.stopPropagation()
  }

  render() {
    return (
      <BaseRow {...this.props}>
        <TableColumn
          htmlType={this.props.htmlType}
          onClick={this.onClickHandle}
          title={this.props.title}
          className={classNames(
            CommonStyles.checkboxColumn,
            {
              [CommonStyles.controlledWidth]: this.props.isCheckboxColumnWidthControlled,
            },
            this.props.checkboxColumnClassName,
          )}>
          <Checkbox
            dataQa="table-check"
            dataQaProps={this.props.dataQaProps}
            title={this.props.title}
            className={CommonStyles.checkbox}
            checked={this.props.isSelected}
            disabled={this.props.isDisabled}
            label=""
            onChange={this.handleCheck}
          />
        </TableColumn>
        {this.props.children}
      </BaseRow>
    )
  }
}

export default CheckboxRow
